import Typography from "antd/es/typography/Typography";
import React from "react";
import ReactApexChart from "react-apexcharts";
const { Title } = Typography;

const SubscribersChart = ({ subscribersTimeline }) => {
  // Get today's date
  const today = new Date().toISOString().split("T")[0];

  // Get all unique dates from the data
  let allDates = [];
  for (let type in subscribersTimeline) {
    allDates = [...allDates, ...Object.keys(subscribersTimeline[type])];
  }

  // Add today's date if it doesn't exist
  if (!allDates.includes(today)) {
    allDates.push(today);
  }
  allDates = [...new Set(allDates)].sort();
  const lineWidth = Math.max(720, allDates.length * 64);
  const tickAmount = Math.min(allDates.length, 8);

  if (!allDates.length || !subscribersTimeline?.global) {
    return (
      <div className="dashboard-empty-state">
        No subscriber timeline data yet.
      </div>
    );
  }

  const fillMissingDates = (typeData) => {
    let filledData = {};
    let lastValue = 0;

    allDates.forEach((date) => {
      // If the date exists in the typeData, update the last value.
      if (typeData[date]) {
        lastValue = typeData[date];
      }

      // Assign the last known value to the date.
      filledData[date] = lastValue;
    });

    return filledData;
  };

  const filledGlobal = fillMissingDates(subscribersTimeline.global || {});
  const filledExpert = fillMissingDates(subscribersTimeline.expert || {});
  const filledCustomer = fillMissingDates(subscribersTimeline.customer || {});
  const filledGuest = fillMissingDates(subscribersTimeline.guest || {});

  const series = [
    {
      name: "Global",
      data: Object.values(filledGlobal),
    },
    {
      name: "Expert",
      data: Object.values(filledExpert),
    },
    {
      name: "Customer",
      data: Object.values(filledCustomer),
    },
    {
      name: "Guest",
      data: Object.values(filledGuest),
    },
  ];

  const options = {
    chart: {
      type: "line",
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: allDates,
      tickAmount,
      labels: {
        style: {
          colors: allDates.map(() => "#688178"),
          fontSize: "12px",
        },
      },
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    grid: {
      borderColor: "rgba(74, 108, 95, 0.12)",
      strokeDashArray: 4,
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
    colors: ["#000000", "#315645", "#008053", "#80CAAC"],
  };

  return (
    <div className="dashboard-panel">
      <div className="dashboard-panel__header">
        <div className="dashboard-panel__header-copy">
          <span className="dashboard-panel__eyebrow">Audience Trends</span>
          <Title level={5}>Subscriber Growth by Segment</Title>
          <span className="dashboard-panel__subtext">
            Compare how global, expert, customer, and guest audiences evolve
            over time.
          </span>
        </div>
        <span className="dashboard-panel__metric">{series.length}</span>
      </div>
      <div className="dashboard-panel__chart">
        <div className="dashboard-panel__chart-inner" style={{ minWidth: lineWidth }}>
        <ReactApexChart
          height={350}
          options={options}
          series={series}
          type="line"
        />
        </div>
      </div>
    </div>
  );
};

export default SubscribersChart;
